import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormGroup, Label, Input, FormFeedback} from 'reactstrap';
import { metadataService } from '../../_services/metadata.service';
import {DatePickerCombo} from '../editors';

export class TextInput extends Component {
    constructor(props) {
        super(props);
        let cssClasses = [];
        if (this.props.maskOnBlur && this.props.value) {
            cssClasses.push("security-mask");
        }
        if (this.props.hideNumberSpinner && this.props.type === "number") {
            cssClasses.push("no-spinner");
        }
        this.state = { visited: false, cssClasses: cssClasses, focused: false }
        this.handleOnBlur = this.handleOnBlur.bind(this);
        this.handleOnFocus = this.handleOnFocus.bind(this);
        this.addMask = this.addMask.bind(this);
        this.removeMask = this.removeMask.bind(this);
    }

    componentDidUpdate(prevProps) {
        if (prevProps.value !== this.props.value) {
            if (!this.state.visited && !this.state.focused) {
                if (this.props.maskOnBlur && this.props.value) {

                    let cssClasses = [];
                    cssClasses.push("security-mask");

                    this.setState({ cssClasses: cssClasses, visited: true });
                }
            }
        }
    }

    handleOnBlur = ({ target: { name, value } }) => {
        if (this.props.maskOnBlur) {
            this.addMask();
        }

        this.setState({ visited: true, focused: true });

        if (this.props.onBlur) {
            this.props.onBlur({ target: { name: name, value: value }});
        }
    }

    handleOnFocus() {
        if (this.props.maskOnBlur) {
            this.removeMask();
        }

        this.setState({focused: true});
    }

    addMask() {
        let currentClasses = this.state.cssClasses;
        if (!currentClasses.includes("security-mask")) {
            currentClasses.push("security-mask");
        }
        this.setState({ cssClasses: currentClasses });
    }

    removeMask() {
        let currentClasses = this.state.cssClasses;
        if (currentClasses.includes("security-mask")) {
            currentClasses.splice(currentClasses.indexOf("security-mask"), 1);
            this.setState({ cssClasses: currentClasses });
        }
    }

    render() {
        const fieldLabel = this.props.label ? this.props.label : metadataService.getFieldNameLabel(this.props.customLabel ? this.props.customLabel : this.props.name);
        let errorMessage = null; 
        let hasError = false; 
        if(this.props.fieldErrors && this.props.fieldErrors.length > 0){
            let fieldError = this.props.fieldErrors.find(e => e.fieldName === this.props.name); 
            if(fieldError){
                hasError = true; 
                errorMessage = metadataService.getMessage(fieldError.messageName, fieldLabel)
            }
        }
        else if (this.props.isRequired && this.state.visited){
            hasError = !this.props.value; 
            errorMessage = metadataService.getMessage('RequiredFieldNotSupplied', fieldLabel)

        }
        let inputProps = {
            name: this.props.name, 
            value: this.props.value, 
            id: this.props.name + '_id',
            min: this.props.min,
            max: this.props.max,
            disabled: this.props.disabled
        }
        if(this.props.maxLength){
            inputProps.maxLength = this.props.maxLength
        }
        if(this.props.type === 'date'){
            return(
                <DatePickerCombo
                    name={this.props.name}
                    value={this.props.value}
                    disabled={this.props.disabled}
                    fieldErrors={this.props.fieldErrors}
                    onChange={this.props.onChange}
                    label={fieldLabel}
                    maskOnBlur={this.props.maskOnBlur} />
            );
        }
        else if(this.props.type === 'number') {
            return (
                <FormGroup>
                    <Label for={this.props.name} hidden={!this.props.showLabel} className={this.props.isRequired && !this.props.disabled ? "required text-input-label" : "text-input-label"}>{fieldLabel}</Label><br />
                    <Input type={this.props.type}
                        invalid={hasError}
                        {...inputProps}
                        onBlur={this.handleOnBlur}
                        onFocus={this.handleOnFocus}
                        onChange={this.props.onChange}
                        onInput={(e) => {
                            if (this.props.maxLength) {
                                if (this.props.allowLeadingZeroes) {
                                    e.target.value = e.target.value.slice(0, this.props.maxLength);
                                }
                                else {
                                    e.target.value = Math.max(0, parseInt(e.target.value, 10)).toString().slice(0, this.props.maxLength);
                                }
                            }
                            if (this.props.max && e.target.value > this.props.max) {
                                e.target.value = this.props.max;
                            }
                        }}
                        className={this.state.cssClasses.join(" ") + " text-field-margin"}
                        placeholder={this.props.placeholder ? this.props.placeholder : ""}
                    />
                    {hasError && (<FormFeedback>{errorMessage}</FormFeedback>)}
                </FormGroup>
            );
        }
        else{
        return (
            <FormGroup>
                <Label for={this.props.name} hidden={!this.props.showLabel} className={this.props.isRequired && !this.props.disabled ? "required text-input-label" : "text-input-label"}>{fieldLabel}</Label><br/>
                <Input type={this.props.type}
                        invalid={hasError}
                        {... inputProps}
                        onBlur={this.handleOnBlur}
                        onFocus={this.handleOnFocus}
                        onChange={this.props.onChange}
                        className={this.state.cssClasses.join(" ") + " text-field-margin"}
                        placeholder=""/>
                    {hasError &&(<FormFeedback>{errorMessage}</FormFeedback> )}
            </FormGroup>
            );
        }
    }
}

//Define prop types
    TextInput.propTypes = {
        name: PropTypes.string.isRequired,
        label:PropTypes.string, 
        showLabel: PropTypes.bool, 
        type: PropTypes.oneOf(['email', 'password', 'url', 'number', 'datetime', 'date', 'time', '']), 
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
        value: PropTypes.string, 
        fieldErrors: PropTypes.array, 
        helpText:PropTypes.string, 
        maxLength:PropTypes.number, 
        isRequired: PropTypes.bool,
        maskOnBlur: PropTypes.bool,
        hideNumberSpinner: PropTypes.bool,
        allowLeadingZeroes: PropTypes.bool,
        placeholder: PropTypes.string,
        disabled: PropTypes.bool,
        customLabel: PropTypes.string
    }
    TextInput.defaultProps = {
        showLabel:true, 
        isRequired: true,
        maskOnBlur: false,
        hideNumberSpinner: false,
        allowLeadingZeroes: false,
        disabled: false
    }


// WEBPACK FOOTER //
// ./src/components/editors/TextInput.jsx